import { MutationTree } from 'vuex'
import { NotesState } from '@/store/modules/notes/notesTypes'

export const mutations: MutationTree<NotesState> = {
  FETCH_NOTES(state, notes) {
    state.notes = notes
  }
}
